import WorkflowRecentsPage from "src/views/products/workflow/pages/WorkflowRecentsPage";
import { FIFTY_FIFTY_NINE_PRODUCT } from "./fiftyFiftyNineProduct";

const FfnRecentsPage = () => (
  <WorkflowRecentsPage product={FIFTY_FIFTY_NINE_PRODUCT} />
);

export default FfnRecentsPage;
